import {Point} from "./Point";

export class Vec2 extends Point {}
